import * as Yup from 'yup';

import {
    ACCOUNT_NUMBER_REGEX,
    ACCOUNT_NUMBER_REGEX_ERROR,
    SORT_CODE_REGEX,
    SORT_CODE_REGEX_ERROR,
} from 'src/components/SortCodeAccountInput/SortCodeAccount.validation';
import { isIreland } from 'src/lib/countryConfig';

const ACCOUNT_NAME_ERROR = 'Account Name is required';
const BANK_NAME_ERROR = 'Bank Name is required';

const IEBankDetailsValidationShape = {
    settlementAccountBic: Yup.string().required('BIC is required'),
    settlementAccountIban: Yup.string().required('IBAN is required'),
    settlementAccountAccountName: Yup.string().required(ACCOUNT_NAME_ERROR),
    settlementAccountBankName: Yup.string().required(BANK_NAME_ERROR),
    chargeableAccountBic: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required('BIC is required'),
        otherwise: Yup.string(),
    }),
    chargeableAccountIban: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required('IBAN is required'),
        otherwise: Yup.string(),
    }),
    chargeableAccountAccountName: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required(ACCOUNT_NAME_ERROR),
        otherwise: Yup.string(),
    }),
    chargeableAccountBankName: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required(BANK_NAME_ERROR),
        otherwise: Yup.string(),
    }),
};

const GBBankDetailsValidationShape = {
    settlementAccountSortCode: Yup.string()
        .matches(SORT_CODE_REGEX, SORT_CODE_REGEX_ERROR)
        .required('Sort Code is required'),
    settlementAccountAccountNumber: Yup.string()
        .matches(ACCOUNT_NUMBER_REGEX, ACCOUNT_NUMBER_REGEX_ERROR)
        .required('Account Number is required'),
    settlementAccountAccountName: Yup.string().required(ACCOUNT_NAME_ERROR),
    settlementAccountBankName: Yup.string().required(BANK_NAME_ERROR),
    settlementAccountBranch: Yup.string().required('Branch is required'),
    settlementAccountAddressLine1: Yup.string().required('Address Line 1 is required'),
    settlementAccountAddressLine2: Yup.string(),
    settlementAccountTown: Yup.string().required('Town is required'),
    settlementAccountPostCode: Yup.string().required('Post Code is required'),
    chargeableAccountSortCode: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string()
            .matches(SORT_CODE_REGEX, SORT_CODE_REGEX_ERROR)
            .required('Sort Code is required'),
        otherwise: Yup.string(),
    }),
    chargeableAccountAccountNumber: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string()
            .matches(ACCOUNT_NUMBER_REGEX, ACCOUNT_NUMBER_REGEX_ERROR)
            .required('Account Number is required'),
        otherwise: Yup.string(),
    }),
    chargeableAccountAccountName: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required(ACCOUNT_NAME_ERROR),
        otherwise: Yup.string(),
    }),
    chargeableAccountBankName: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required(BANK_NAME_ERROR),
        otherwise: Yup.string(),
    }),
    chargeableAccountBranch: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required('Branch is required'),
        otherwise: Yup.string(),
    }),
    chargeableAccountAddressLine1: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required('Address Line 1 is required'),
        otherwise: Yup.string(),
    }),
    chargeableAccountAddressLine2: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string(),
        otherwise: Yup.string(),
    }),
    chargeableAccountTown: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required('Town is required'),
        otherwise: Yup.string(),
    }),
    chargeableAccountPostCode: Yup.string().when(['settlementAccountSameAsChargeable'], {
        is: false,
        then: Yup.string().required('Post Code is required'),
        otherwise: Yup.string(),
    }),
};

const bankDetailsValidationShape = isIreland
    ? IEBankDetailsValidationShape
    : GBBankDetailsValidationShape;

export default bankDetailsValidationShape;
